import { useUIStore } from "@/stores";
import { Add, Remove } from "@mui/icons-material";
import { Button, IconButton, Stack, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { FC, useState } from "react";
import { ReplenishInvitesProps } from "./replenish-invites.types";
import { useReplenishInvites } from "@/queries";

const ReplenishInvites: FC<ReplenishInvitesProps> = ({ userId }) => {
  const { closeModal } = useUIStore();
  const [inviteCount, setInviteCount] = useState(0);

  const { replenishInvites, replenishInvitesIsPending } =
    useReplenishInvites(closeModal);

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    replenishInvites({ userId, invitesCount: inviteCount });
  };

  const handleIncrement = () => setInviteCount((prev) => prev + 1);
  const handleDecrement = () => setInviteCount((prev) => Math.max(prev - 1, 0));

  return (
    <form onSubmit={onSubmit}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        spacing={2}
      >
        <IconButton disabled={!inviteCount} onClick={handleDecrement}>
          <Remove />
        </IconButton>

        <Typography
          variant="h6"
          sx={{
            color: "white",
            border: "1px solid #7C7C7C",
            borderRadius: 2,
            background: grey[900],
            px: 2,
            py: 1,
          }}
        >
          {inviteCount}
        </Typography>

        <IconButton onClick={handleIncrement}>
          <Add />
        </IconButton>
      </Stack>

      <Stack
        direction="row"
        spacing={2}
        sx={{ mt: 4, justifyContent: "center" }}
      >
        <Button
          fullWidth
          color="primary"
          variant="contained"
          disabled={replenishInvitesIsPending}
          onClick={closeModal}
        >
          Cancel
        </Button>
        <Button
          fullWidth
          type="submit"
          color="secondary"
          variant="contained"
          loading={replenishInvitesIsPending}
          disabled={!inviteCount || replenishInvitesIsPending}
        >
          Save
        </Button>
      </Stack>
    </form>
  );
};

export { ReplenishInvites };
